var React = require('react');

function Diamond (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.1598 7.1842L19.2327 3.21844C18.6671 2.45219 17.7713 2 16.8189 2H7.18107C6.22871 2 5.33291 2.45219 4.76735 3.21844L1.84025 7.1842C1.04652 8.25957 1.05993 9.73033 1.87315 10.791L9.61919 20.8946C10.82 22.4609 13.18 22.4609 14.3808 20.8946L22.1269 10.791C22.9401 9.73033 22.9535 8.25957 22.1598 7.1842ZM3.72389 8L6.3765 4.40615C6.56502 4.15073 6.86362 4 7.18107 4H16.8189C17.1364 4 17.435 4.15073 17.6235 4.40615L20.2761 8H3.72389ZM3.78682 10L11.2064 19.6777C11.6067 20.1998 12.3933 20.1998 12.7936 19.6777L20.2132 10H3.78682Z","fill":"black"}));
}

Diamond.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Diamond;

Diamond.default = Diamond;
